import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
  Flex
} from "@chakra-ui/react";
import Description from "./Description";

interface Props {
  descriptions: any[];
}
const Section: React.FC<Props> = ({ descriptions }: Props) => {
  return (
    <Flex
      direction="column"
      p={[0, 6]}
      bgColor="gray.800"
      color="white"
      roundedRight={{ md: 8 }}
      width="100%"
    >
      <Accordion allowToggle>
        {descriptions.length > 0 &&
          descriptions.map((description, index) => (
            <AccordionItem borderColor="gray.600" key={index}>
              <h2>
                <AccordionButton _expanded={{ fontWeight: "bold" }}>
                  <Box flex="1" textAlign="left">
                    {description.versiondate}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <Description description={description}>test</Description>
            </AccordionItem>
          ))}
      </Accordion>
    </Flex>
  );
};

export default Section;
